var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.6026 78.03L81.6543 70.0832C80.6246 69.0536 78.9551 69.0536 77.9255 70.0833C76.8958 71.113 76.896 72.7826 77.9257 73.8123L81.372 77.2578H13.5963V9.48245L17.043 12.929C17.5579 13.4437 18.2325 13.701 18.9074 13.701C19.5822 13.701 20.2572 13.4435 20.7719 12.9288C21.8016 11.8989 21.8016 10.2295 20.7717 9.1998L12.824 1.25276C11.7942 0.223038 10.1248 0.223038 9.0953 1.25276L1.14738 9.1998C0.117659 10.2295 0.117482 11.8989 1.1472 12.9288C2.17675 13.9584 3.84631 13.9585 4.87603 12.929L8.32292 9.48245V77.2578H3.01171C1.55554 77.2578 0.375 78.4385 0.375 79.8945C0.375 81.351 1.55554 82.5312 3.01171 82.5312H8.32292V87.8435C8.32292 89.2996 9.50346 90.4802 10.9596 90.4802C12.4158 90.4802 13.5963 89.2996 13.5963 87.8435V82.5312H81.3731L77.9255 85.9792C76.8958 87.0089 76.896 88.6783 77.9257 89.7082C78.4406 90.2228 79.1152 90.4802 79.79 90.4802C80.4648 90.4802 81.1397 90.2227 81.6545 89.708L89.6028 81.759C90.0973 81.2644 90.375 80.5939 90.375 79.8945C90.375 79.1953 90.0971 78.5245 89.6026 78.03Z",
    fill: "url(#paint0_linear_298_30669)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3589 41.9051V55.3769C28.3589 56.476 27.4645 57.3701 26.365 57.3701C25.2657 57.3701 24.3713 56.476 24.3713 55.3769V41.9051C24.3713 40.8057 25.2657 39.9117 26.3652 39.9117C27.4645 39.9117 28.3589 40.8057 28.3589 41.9051ZM19.0979 41.9051V55.3769C19.0979 58.4539 21.0215 61.0885 23.7285 62.1464V65.8163C23.7285 67.2726 24.909 68.453 26.3652 68.453C27.8214 68.453 29.0019 67.2726 29.0019 65.8163V62.1464C31.7089 61.0885 33.6323 58.4539 33.6323 55.3769V41.9051C33.6323 38.828 31.7089 36.1934 29.0019 35.1354V31.4653C29.0019 30.0093 27.8214 28.8286 26.3652 28.8286C24.909 28.8286 23.7285 30.0093 23.7285 31.4653V35.1354C21.0215 36.1932 19.0979 38.8278 19.0979 41.9051Z",
    fill: "url(#paint1_linear_298_30669)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.237 21.5688C43.237 20.4697 44.1315 19.5755 45.231 19.5755C46.3304 19.5755 47.2247 20.4697 47.2247 21.5688V35.0406C47.2247 36.14 46.3302 37.0338 45.2307 37.0338C44.1313 37.0338 43.237 36.14 43.237 35.0406V21.5688ZM42.5941 41.8101V45.4803C42.5941 46.9364 43.7747 48.117 45.2309 48.117C46.687 48.117 47.8676 46.9364 47.8676 45.4803V41.8101C50.5748 40.7525 52.4981 38.1179 52.4981 35.0406V21.5688C52.4981 18.4918 50.5748 15.8574 47.8676 14.7993V11.1292C47.8676 9.67288 46.687 8.49251 45.2309 8.49251C43.7747 8.49251 42.5941 9.67288 42.5941 11.1292V14.7992C39.8871 15.8572 37.9636 18.4918 37.9636 21.5688V35.0406C37.9636 38.1179 39.8871 40.7523 42.5941 41.8101Z",
    fill: "url(#paint2_linear_298_30669)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1017 41.9051C62.1017 40.8057 62.9961 39.9117 64.0956 39.9117C65.195 39.9117 66.0893 40.8057 66.0893 41.9051V55.3769C66.0893 56.476 65.1948 57.3701 64.0954 57.3701C62.9961 57.3701 62.1017 56.476 62.1017 55.3769V41.9051ZM61.4587 62.1462V65.8163C61.4587 67.2726 62.6393 68.453 64.0954 68.453C65.5516 68.453 66.7321 67.2726 66.7321 65.8163V62.1464C69.4392 61.0885 71.3627 58.4539 71.3627 55.3769V41.9051C71.3627 38.8278 69.4392 36.1934 66.7321 35.1354V31.4653C66.7321 30.0093 65.5516 28.8286 64.0954 28.8286C62.6393 28.8286 61.4587 30.0093 61.4587 31.4653V35.1354C58.7517 36.1934 56.8283 38.8278 56.8283 41.9051V55.3769C56.8283 58.4539 58.7517 61.0883 61.4587 62.1462Z",
    fill: "url(#paint3_linear_298_30669)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9665 21.5688C80.9665 20.4697 81.8611 19.5755 82.9606 19.5755C84.0597 19.5755 84.9539 20.4697 84.9539 21.5688V35.0406C84.9539 36.14 84.0597 37.0338 82.9606 37.0338C81.8611 37.0338 80.9665 36.14 80.9665 35.0406V21.5688ZM80.3239 41.8101V45.4803C80.3239 46.9364 81.5044 48.117 82.9606 48.117C84.4167 48.117 85.5973 46.9364 85.5973 45.4803V41.8101C88.3041 40.7521 90.2273 38.1177 90.2273 35.0406V21.5688C90.2273 18.4918 88.3041 15.8574 85.5973 14.7993V11.1292C85.5973 9.67288 84.4167 8.49251 82.9606 8.49251C81.5044 8.49251 80.3239 9.67288 80.3239 11.1292V14.7992C77.6167 15.8572 75.6931 18.4918 75.6931 21.5688V35.0406C75.6931 38.1179 77.6167 40.7523 80.3239 41.8101Z",
    fill: "url(#paint4_linear_298_30669)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_298_30669",
    x1: 0.375,
    y1: 45.4803,
    x2: 90.3748,
    y2: 45.6297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D129DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CDBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_298_30669",
    x1: 0.375,
    y1: 45.4803,
    x2: 90.3748,
    y2: 45.6297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D129DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CDBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_298_30669",
    x1: 0.375,
    y1: 45.4803,
    x2: 90.3748,
    y2: 45.6297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D129DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CDBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_298_30669",
    x1: 0.375,
    y1: 45.4803,
    x2: 90.3748,
    y2: 45.6297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D129DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CDBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_298_30669",
    x1: 0.375,
    y1: 45.4803,
    x2: 90.3748,
    y2: 45.6297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D129DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CDBFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrader);
export default __webpack_public_path__ + "static/media/trader.e29aceebe623a8ae147b768da10bd1c5.svg";
export { ForwardRef as ReactComponent };